export const SUBMENU_RAIL_WIDTH = 12;
export const SUBMENU_STROKE_WIDTH = 1.5;

const BRANCH_CURVE_OFFSET = 6;

export function buildSubmenuPath(branchY: number): string {
  const verticalEnd = Math.max(1, branchY - BRANCH_CURVE_OFFSET);
  return `M 1 1 V ${verticalEnd} C 1 ${verticalEnd + 3.3137} 3.68629 ${branchY} 7 ${branchY} H 11`;
}

export function buildBranchPath(branchY: number): string {
  const verticalEnd = Math.max(1, branchY - BRANCH_CURVE_OFFSET);
  const spineStart = Math.max(1, verticalEnd - 1);
  return `M 1 ${spineStart} V ${verticalEnd} C 1 ${verticalEnd + 3.3137} 3.68629 ${branchY} 7 ${branchY} H 11`;
}

/** Cumulative paths stacked together form one continuous tree (spine + all branches). */
export function buildInactiveTreePaths(branchYs: number[]): string[] {
  return branchYs.map((branchY) => buildSubmenuPath(branchY));
}

export function getRailHeight(branchYs: number[]): number {
  if (branchYs.length === 0) return 0;
  return Math.max(...branchYs) + BRANCH_CURVE_OFFSET + 1;
}

export function roundBranchY(y: number): number {
  return Math.round(y * 2) / 2;
}
